var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderQrNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "338 14 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 350.91,
    y: 32.39,
    width: 1.72,
    height: 1.72
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 355.85,
    y: 32.39,
    width: 1.72,
    height: 1.72
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 353.38,
    y: 29.98,
    width: 1.72,
    height: 1.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M356.8,28.99h-5.11c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h5.11c.42,0,.76.34.76.76s-.34.76-.76.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M347.85,34.1h-4.19c-.67,0-1.22-.55-1.22-1.22v-4.19c0-.67.55-1.22,1.22-1.22h4.19c.67,0,1.22.55,1.22,1.22v4.19c0,.67-.55,1.22-1.22,1.22ZM343.96,32.58h3.59v-3.59h-3.59v3.59ZM347.85,28.99h0,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M347.85,25.6h-4.19c-.67,0-1.22-.55-1.22-1.22v-4.19c0-.67.55-1.22,1.22-1.22h4.19c.67,0,1.22.55,1.22,1.22v4.19c0,.67-.55,1.22-1.22,1.22ZM343.96,24.09h3.59v-3.59h-3.59v3.59ZM347.85,20.49h0,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M356.34,25.6h-4.19c-.67,0-1.22-.55-1.22-1.22v-4.19c0-.67.55-1.22,1.22-1.22h4.19c.67,0,1.22.55,1.22,1.22v4.19c0,.67-.55,1.22-1.22,1.22ZM352.44,24.09h3.59v-3.59h-3.59v3.59ZM356.34,20.49h0,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M339.76,21.64c-.42,0-.76-.34-.76-.76v-2.75c0-1.43,1.16-2.6,2.6-2.6h2.75c.42,0,.76.34.76.76s-.34.76-.76.76h-2.75c-.6,0-1.08.48-1.08,1.08v2.75c0,.42-.34.76-.76.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M360.24,21.64c-.42,0-.76-.34-.76-.76v-2.75c0-.6-.48-1.08-1.08-1.08h-2.75c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h2.75c1.43,0,2.6,1.16,2.6,2.6v2.75c0,.42-.34.76-.76.76Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M344.35,37.54h-2.75c-1.43,0-2.6-1.16-2.6-2.6v-2.75c0-.42.34-.76.76-.76s.76.34.76.76v2.75c0,.6.48,1.08,1.08,1.08h2.75c.42,0,.76.34.76.76s-.34.76-.76.76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M358.4,37.54h-2.75c-.42,0-.76-.34-.76-.76s.34-.76.76-.76h2.75c.6,0,1.08-.48,1.08-1.08v-2.75c0-.42.34-.76.76-.76s.76.34.76.76v2.75c0,1.43-1.16,2.6-2.6,2.6Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 344.9,
    y: 21.43,
    width: 1.72,
    height: 1.72
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 353.38,
    y: 21.43,
    width: 1.72,
    height: 1.72
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 344.9,
    y: 29.93,
    width: 1.72,
    height: 1.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderQrNav);
export default __webpack_public_path__ + "static/media/header-qr-nav.f4226753d355a6a3ed5ad2c7b8a33288.svg";
export { ForwardRef as ReactComponent };